export const SIDE_BY_SIDE = 'side-by-side';
export const CARD = 'card';
